import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  margin: 20px;

  .copytable-textarea-component-container {
    padding: 0;
  }

  .summary-box {
    margin-top: 3px;
    padding-right: 8px;
    color: var(--grey-1);
    font-style: italic;
    font-weight: 500;
    line-height: 1.3;

    .current-chapter {
      font-weight: 700;
    }

    .note {
      margin-bottom: 18px;
    }

    .show-hide-summary {
      font-weight: 500;
      font-style: underline;
      border-bottom: 1px solid;
      cursor: pointer;
    }
  }

  .textarea-header {
    padding: 5px 20px 0;
    .left-container {
      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }

  .textarea-container {
    padding: 5px 20px 17px 20px !important;
  }

  textarea {
    color: var(--grey-0);
    background: var(--menu-color-fullscreen);
    border-radius: 12px;
    border: 1.5px solid var(--grey-2);
    box-sizing: border-box;
    width: 100%;
    height: 450px;
    font-size: 18px;
    padding: 1em;
    min-height: 300px;
    margin-bottom: 1em;
    line-height: 1.4em;
    font-family: "Inter";
  }

  &.prose-generator textarea:focus {
    border: 1.5px solid var(--primary-cta-high-contrast);
  }

  &.paused,
  &.scrolled-down {
    position: sticky;
    // we set top dynamically in the component
    // the position is based on the height of the prose generator
    margin-top: 20px;
    z-index: 100;
  }

  button {
    &:disabled {
      background: var(--grey-2) !important;
    }
  }

  .outline-link-missing-cta {
    background-color: var(--grey-3);
    opacity: 0.75;
    padding: 15px;
    border-radius: 13px;
    color: var(--grey-1);
    margin: 15px 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 20px;
    font-weight: 500;

    a {
      color: var(--grey-1);
      text-decoration: underline;
      line-height: 1.6;
    }
  }

  .main-header {
    border-bottom: 2px solid var(--divider);

    .inner {
      padding: 20px 12px 20px 20px;
    }
    .no-scene-summary {
      padding: 20px 12px 10px 20px;
    }

    .left-container {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .icon-button-close {
        z-index: 1000;
        cursor: pointer;
        transform: translateY(-9px);
        // width: 26px;
        // height: 26px;
        // .icon-button-close {
        //   width: 26px;
        //   height: 26px;
        // }
        .hover-tip {
          max-width: 50px;
        }

        svg {
          // height: 19px;
          transform: rotate(90deg);
          g {
            opacity: 1;
          }
          path {
            fill: var(--grey-0);
            stroke: none;
          }
          rect {
            fill: none;
          }
        }

        &:hover {
          svg {
            path {
              fill: var(--grey-0);
            }
          }
        }
      }
    }

    .title {
      font-weight: 500;
      font-size: 20px;
      color: var(--grey-0);
      display: flex;
      align-items: center;
      svg {
        margin-right: 8px;
        width: 30px;
        height: 30px;
        path {
          fill: var(--icon-button-fill);
        }
        circle {
          fill: var(--icon-button-fill);
        }
        rect {
          fill: var(--icon-button-fill);
        }

        // typewriter svg is a little different
        // so it gets special treatment
        &.generator-icon {
          width: 24px;
          height: 24px;
          margin-right: 16px;
          rect {
            fill: none;
          }
        }
      }
    }
  }

  .parsed-beats {
    min-height: 10px;
    flex-basis: 100%;
  }

  .left-container {
    display: flex;
    align-items: center;
    gap: 10px;

    .help {
      line-height: 21px;
      border-radius: 25px;
      height: 21px;
      width: 21px;
      position: relative;
      color: var(--menu-color-fullscreen);
      display: block;
      padding: 0;
      font-weight: bold;
      font-size: 17px;
      text-align: center;
      background: var(--grey-2);
    }
  }
`;
